/**
 * Imperative DOM UI helpers for tour celebrations.
 * No React dependency — uses vanilla DOM directly.
 */

export const clearCelebrationPopups = () => {
  document
    .querySelectorAll('[data-tour="tour-celebration-popup"]')
    .forEach((node) => node.remove());
};

export const showCelebrationPopup = (
  title: string,
  message: string,
  emoji = "✨ 🎉 ✨",
) => {
  clearCelebrationPopups();
  const popup = document.createElement("div");
  popup.setAttribute("data-tour", "tour-celebration-popup");
  popup.className = "tour-celebration-popup";
  popup.innerHTML = `
    <div class="tour-celebration-inner">
      <div class="tour-celebration-burst" aria-hidden="true">${emoji}</div>
      <h3>${title}</h3>
      <p>${message}</p>
    </div>
  `;
  document.body.appendChild(popup);
  return () => {
    if (popup.isConnected) {
      popup.remove();
    }
  };
};
